import script from "./HelpCenterIntro.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpCenterIntro.vue?vue&type=script&setup=true&lang=ts"

import "./HelpCenterIntro.vue?vue&type=style&index=0&id=47abfc4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47abfc4e"]])

export default __exports__